import { render } from "./AssignedBetttingShop.vue?vue&type=template&id=5bbf2966"
import script from "./AssignedBetttingShop.vue?vue&type=script&lang=js"
export * from "./AssignedBetttingShop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__